import { ImagesType } from "@features/images/type";

interface StudioRemixProps {
  image: ImagesType;
  onAction: (action: string) => void;
}

export const StudioRemix = ({ image, onAction }: StudioRemixProps) => {
  return (
    <div className="space-y-4">
      <div className="text-center text-gray-500">
        <p>Remix functionality coming soon...</p>
        <p className="text-sm">Modify background, clothing, hairstyle, etc.</p>
      </div>
    </div>
  );
};
